import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Spinner, Alert, Badge, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import Footer from '../components/Footer';

const PerfilUsuario = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [updatingNotification, setUpdatingNotification] = useState(false);

  // Determinar si es portal público (proveedor) o admin
  const isPublicPortal = user && user.rol === 2;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    loadUserData();
  }, [isAuthenticated, navigate]);

  const loadUserData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/api/v1/auth/me');
      setUserData(response.data);
    } catch (err) {
      console.error('Error loading user data:', err);
      setError('Error al cargar la información del usuario');
    } finally {
      setLoading(false);
    }
  };

  const getRolName = (rol) => {
    switch (rol) {
      case 1:
        return 'Administrador';
      case 2:
        return 'Proveedor';
      case 3:
        return 'Evaluador';
      default:
        return 'Usuario';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-PE', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  const handleToggleNotificaciones = async () => {
    if (!userData) return;
    const nuevoValor = !userData.notificar_convcatoria;
    setUpdatingNotification(true);
    try {
      const response = await api.patch('/api/v1/usuarios/me/notificar-convocatorias', { notificar: nuevoValor });
      setUserData(response.data);
    } catch (err) {
      console.error('Error actualizando preferencia de notificaciones:', err);
      alert('Error al actualizar la preferencia de notificaciones');
    } finally {
      setUpdatingNotification(false);
    }
  };

  if (loading) {
    if (isPublicPortal) {
      return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
          <div style={{ 
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/fondo.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            padding: '2rem 0',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <Container>
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <img 
                      src="/LOGO-DIRESA.png" 
                      alt="Logo DIRESA" 
                      className="me-3"
                      style={{ 
                        height: '72px', 
                        objectFit: 'contain',
                      }}
                    />
                    <div>
                      <h1 className="text-white mb-1 fw-bold" style={{ fontSize: '1.75rem' }}>
                        Información de Usuario
                      </h1>
                      <p className="text-white-50 mb-0 small">DIRESA - Portal Público</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <Container className="py-5">
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          </Container>
          <Footer />
        </div>
      );
    }
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    if (isPublicPortal) {
      return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
          <div style={{ 
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/fondo.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            padding: '2rem 0',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <Container>
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <img 
                      src="/LOGO-DIRESA.png" 
                      alt="Logo DIRESA" 
                      className="me-3"
                      style={{ 
                        height: '72px', 
                        objectFit: 'contain',
                      }}
                    />
                    <div>
                      <h1 className="text-white mb-1 fw-bold" style={{ fontSize: '1.75rem' }}>
                        Información de Usuario
                      </h1>
                      <p className="text-white-50 mb-0 small">DIRESA - Portal Público</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <Container className="py-5">
            <Alert variant="danger">{error}</Alert>
          </Container>
          <Footer />
        </div>
      );
    }
    return (
      <Alert variant="danger">{error}</Alert>
    );
  }

  if (!userData) {
    if (isPublicPortal) {
      return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
          <div style={{ 
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/fondo.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            padding: '2rem 0',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <Container>
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <img 
                      src="/LOGO-DIRESA.png" 
                      alt="Logo DIRESA" 
                      className="me-3"
                      style={{ 
                        height: '72px', 
                        objectFit: 'contain',
                      }}
                    />
                    <div>
                      <h1 className="text-white mb-1 fw-bold" style={{ fontSize: '1.75rem' }}>
                        Información de Usuario
                      </h1>
                      <p className="text-white-50 mb-0 small">DIRESA - Portal Público</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <Container className="py-5">
            <Alert variant="warning">No se pudo cargar la información del usuario</Alert>
          </Container>
          <Footer />
        </div>
      );
    }
    return (
      <Alert variant="warning">No se pudo cargar la información del usuario</Alert>
    );
  }

  // Contenido del Card.Header (común para ambos estilos)
  const cardHeaderContent = (
    <div className="d-flex align-items-center">
      <div style={{
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: isPublicPortal ? 'rgba(46, 125, 50, 0.15)' : 'rgba(52, 152, 219, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
        border: `2px solid ${isPublicPortal ? 'rgba(46, 125, 50, 0.2)' : 'rgba(52, 152, 219, 0.2)'}`
      }}>
        <i className="bi bi-person-fill" style={{ fontSize: '2rem', color: isPublicPortal ? '#2e7d32' : '#3498db' }}></i>
      </div>
      <div>
        <h4 className="mb-0 fw-bold" style={{ color: '#2b3e53' }}>{userData.razon_social || userData.email}</h4>
        <Badge bg={isPublicPortal ? 'success' : 'primary'} className="mt-1" style={{ fontSize: '0.75rem' }}>
          {getRolName(userData.rol)}
        </Badge>
      </div>
    </div>
  );

  // Si es portal público, mostrar con header y footer
  if (isPublicPortal) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
        {/* Header con fondo y logo, consistente con Mis Postulaciones */}
        <div style={{ 
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/fondo.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          padding: '2rem 0',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <div className="d-flex align-items-center">
                  <img 
                    src="/LOGO-DIRESA.png" 
                    alt="Logo DIRESA" 
                    className="me-3"
                    style={{ 
                      height: '72px', 
                      objectFit: 'contain',
                    }}
                  />
                  <div>
                    <h1 className="text-white mb-1 fw-bold" style={{ fontSize: '1.75rem' }}>
                      Información de Usuario
                    </h1>
                    <p className="text-white-50 mb-0 small">DIRESA - Portal Público</p>
                  </div>
                </div>
              </Col>
              <Col md={6} className="text-end">
                <Button as={Link} to="/" variant="light" className="px-4">
                  Volver al inicio
                </Button>
                {Number(userData?.rol) === 2 && (
                  <Button as={Link} to="/mis-ordenes" variant="outline-light" className="px-4 ms-2">
                    Mis órdenes
                  </Button>
                )}
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="py-5">
          <Row>
            <Col lg={8} className="mx-auto">
              <Card className="shadow-sm border-0">
                <Card.Header style={{ 
                  background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 50%, #a5d6a7 100%)',
                  color: '#2b3e53',
                  border: 'none',
                  padding: '1.5rem',
                  borderBottom: '2px solid #81c784'
                }}>
                  {cardHeaderContent}
                </Card.Header>
            <Card.Body className="p-4">
              <Row className="g-4">
                {/* Información Básica */}
                <Col xs={12}>
                  <h5 className="fw-semibold mb-3" style={{ color: '#667eea' }}>
                    <i className="bi bi-info-circle me-2"></i>
                    Información Básica
                  </h5>
                </Col>
                
                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      TIPO DE PERSONA
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.tipo_persona || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      RUC
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.ruc || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      RAZÓN SOCIAL
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.razon_social || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      EMAIL
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.email || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      CELULAR
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.celular || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      DIRECCIÓN
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.direccion || 'N/A'}
                    </div>
                  </div>
                </Col>

                {/* Estado y Configuración */}
                <Col xs={12} className="mt-3">
                  <hr />
                  <h5 className="fw-semibold mb-3" style={{ color: '#667eea' }}>
                    <i className="bi bi-gear me-2"></i>
                    Estado y Configuración
                  </h5>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      ESTADO
                    </small>
                    <div>
                      <Badge bg={userData.estado ? 'success' : 'danger'}>
                        {userData.estado ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      EMAIL VERIFICADO
                    </small>
                    <div>
                      <Badge bg={userData.is_email_verified ? 'success' : 'warning'}>
                        {userData.is_email_verified ? 'Verificado' : 'No Verificado'}
                      </Badge>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      FECHA DE REGISTRO
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {formatDate(userData.fecha_registro)}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      ID DE USUARIO
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      #{userData.id_usuario}
                    </div>
                  </div>
                </Col>

                {/* Preferencia de Notificaciones - Solo para proveedores */}
                {isPublicPortal && (
                  <Col xs={12}>
                    <div className="mb-3 p-3 border rounded" style={{ 
                      backgroundColor: '#f8f9fa',
                      borderColor: '#dee2e6'
                    }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                            NOTIFICACIONES DE CONVOCATORIAS
                          </small>
                          <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.9rem' }}>
                            {userData.notificar_convcatoria !== undefined 
                              ? (userData.notificar_convcatoria ? 'Recibir notificaciones' : 'No recibir notificaciones')
                              : 'Recibir notificaciones'}
                          </div>
                          <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                            {userData.notificar_convcatoria !== undefined && userData.notificar_convcatoria
                              ? 'Recibirás avisos por email cuando se publiquen nuevas convocatorias'
                              : 'No recibirás avisos por email de nuevas convocatorias'}
                          </small>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="notificarConvocatorias"
                            checked={userData.notificar_convcatoria !== undefined ? userData.notificar_convcatoria : true}
                            onChange={handleToggleNotificaciones}
                            disabled={updatingNotification}
                            style={{ 
                              width: '3rem', 
                              height: '1.5rem',
                              cursor: updatingNotification ? 'not-allowed' : 'pointer'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }

  // Si es admin/evaluador, mostrar estilo simple sin header ni footer
  return (
    <div>
      <Row>
        <Col lg={8} className="mx-auto">
          <Card className="shadow-sm border-0">
            <Card.Header style={{ 
              backgroundColor: '#2b3e53',
              color: 'white',
              border: 'none',
              padding: '1.5rem',
              borderBottom: '3px solid #3498db'
            }}>
              {cardHeaderContent}
            </Card.Header>
            <Card.Body className="p-4">
              <Row className="g-4">
                {/* Información Básica */}
                <Col xs={12}>
                  <h5 className="fw-semibold mb-3" style={{ color: '#667eea' }}>
                    <i className="bi bi-info-circle me-2"></i>
                    Información Básica
                  </h5>
                </Col>
                
                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      TIPO DE PERSONA
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.tipo_persona || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      RUC
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.ruc || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      RAZÓN SOCIAL
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.razon_social || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      EMAIL
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.email || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      CELULAR
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.celular || 'N/A'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      DIRECCIÓN
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {userData.direccion || 'N/A'}
                    </div>
                  </div>
                </Col>

                {/* Estado y Configuración */}
                <Col xs={12} className="mt-3">
                  <hr />
                  <h5 className="fw-semibold mb-3" style={{ color: '#667eea' }}>
                    <i className="bi bi-gear me-2"></i>
                    Estado y Configuración
                  </h5>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      ESTADO
                    </small>
                    <div>
                      <Badge bg={userData.estado ? 'success' : 'danger'}>
                        {userData.estado ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      EMAIL VERIFICADO
                    </small>
                    <div>
                      <Badge bg={userData.is_email_verified ? 'success' : 'warning'}>
                        {userData.is_email_verified ? 'Verificado' : 'No Verificado'}
                      </Badge>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      FECHA DE REGISTRO
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      {formatDate(userData.fecha_registro)}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      ID DE USUARIO
                    </small>
                    <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.95rem' }}>
                      #{userData.id_usuario}
                    </div>
                  </div>
                </Col>

                {/* Preferencia de Notificaciones - Solo para proveedores */}
                {isPublicPortal && (
                  <Col xs={12}>
                    <div className="mb-3 p-3 border rounded" style={{ 
                      backgroundColor: '#f8f9fa',
                      borderColor: '#dee2e6'
                    }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <small className="text-muted d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                            NOTIFICACIONES DE CONVOCATORIAS
                          </small>
                          <div className="fw-semibold" style={{ color: '#2b3e53', fontSize: '0.9rem' }}>
                            {userData.notificar_convcatoria !== undefined 
                              ? (userData.notificar_convcatoria ? 'Recibir notificaciones' : 'No recibir notificaciones')
                              : 'Recibir notificaciones'}
                          </div>
                          <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                            {userData.notificar_convcatoria !== undefined && userData.notificar_convcatoria
                              ? 'Recibirás avisos por email cuando se publiquen nuevas convocatorias'
                              : 'No recibirás avisos por email de nuevas convocatorias'}
                          </small>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="notificarConvocatorias"
                            checked={userData.notificar_convcatoria !== undefined ? userData.notificar_convcatoria : true}
                            onChange={handleToggleNotificaciones}
                            disabled={updatingNotification}
                            style={{ 
                              width: '3rem', 
                              height: '1.5rem',
                              cursor: updatingNotification ? 'not-allowed' : 'pointer'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PerfilUsuario;

